import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { TrendingUp, DollarSign, Clock, BarChart3, Users, Target } from 'lucide-react';
const achievements = [{
  metric: '75%',
  label: 'Cost Savings',
  description: 'Delivered by enforcing PMO governance and controls across multiple initiatives',
  icon: DollarSign
}, {
  metric: '$50M',
  label: 'Program Leadership',
  description: 'Led Veteran Appeals modernization program, improving delivery performance by 30%',
  icon: Users
}, {
  metric: '45%',
  label: 'Completion Rate Increase',
  description: 'Achieved through structured change management and collaboration',
  icon: BarChart3
}, {
  metric: '45%',
  label: 'Timeline Reduction',
  description: 'Reduced implementation timelines using Agile delivery models and SaaS dashboards',
  icon: Clock
}, {
  metric: '30%',
  label: 'Efficiency Gain',
  description: 'Improved operational efficiency through ERP and supply chain modernization',
  icon: TrendingUp
}, {
  metric: '40+',
  label: 'Team Members Led',
  description: 'Managed cross-functional teams across procurement, operations, finance, IT, HR, and PMO',
  icon: Target
}];
export function Achievements() {
  return <Section id="achievements" background="navy" className="relative overflow-hidden" data-id="element-36" data-mp="3nxp29z90y4qt">
      {/* Silver Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1e3a8a] via-[#1e293b] to-[#0f172a]" data-id="element-37" data-mp="3sw9upci1bk4p"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-gray-400/10 via-transparent to-transparent blur-3xl" data-id="element-38" data-mp="3dyzooio5v6gd"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-tr from-blue-400/10 via-transparent to-transparent blur-3xl" data-id="element-39" data-mp="22km01bll2mza"></div>

      <div className="relative z-10" data-id="element-40" data-mp="27l082tn6pwxb">
        <FadeIn className="text-center mb-16" data-id="element-41" data-mp="e0q7i7mrj0s5">
          <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-white mb-4 drop-shadow-lg" data-id="element-42" data-mp="dzexhq2q4wsl">
            Key Achievements
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-43" data-mp="49ve8jb3n0x7">
            Delivering measurable impact through strategic leadership and
            operational excellence.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-44" data-mp="3qj6eok213r4t">
          {achievements.map((item, index) => <StaggerItem key={index} className="relative group" data-id="element-45" data-mp="3miw6d0qrkoms" data-mpi={index}>
              {/* Metallic Card Background */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-gray-300/5 to-white/10 backdrop-blur-xl rounded-xl border border-white/20 shadow-2xl" data-id="element-46" data-mp="3cic2dqbv160v"></div>

              {/* Silver Shine Effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl" data-id="element-47" data-mp="1aqh5why6d838"></div>

              <div className="relative p-8" data-id="element-48" data-mp="1n92zspa2y1rp">
                <div className="flex items-center justify-between mb-4" data-id="element-49" data-mp="1n80aglseo7dw">
                  <span className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-white via-gray-200 to-gray-300 drop-shadow-lg" data-id="element-50" data-mp="1s1cknqwc8bn4">
                    {item.metric}
                  </span>
                  <div className="p-3 bg-gradient-to-br from-gray-300/20 to-blue-300/20 rounded-lg backdrop-blur-sm" data-id="element-51" data-mp="zcxi43ue7lso">
                    <item.icon className="w-8 h-8 text-gray-200 drop-shadow-lg" data-id="element-52" data-mp="14az2qt7gvt69" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-100 mb-2 drop-shadow-md" data-id="element-53" data-mp="1e8wrrix5htzx">
                  {item.label}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-54" data-mp="2knxecy0acztu">
                  {item.description}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </Section>;
}